import axios from 'axios';
import urls from './urls';

const userManager = axios.create({
    baseURL: `${urls.api}/auth`,
    withCredentials: true
});

export const signIn = (data) => {
    return userManager.post('/login', data);
}

export const register = (data) => {
    return userManager.post('/register', data);
}

export const logOut = () => {
    return userManager.get('/logout');
}

export const check = () => {
    return userManager.get('/check');
}

export const recoverPassword = (data) => {
    return userManager.post('/recover_password', data);
}

export const changePassword = (data) => {
    return userManager.post('/change_password', data);
}

export default {
    signIn,
    logOut,
    register,
    check,
    recoverPassword,
    changePassword
};